import { callPostApiv2, callGetApiv2 } from "./api";

export async function getAuditTrailReportList(data) {
  try {
    return await callPostApiv2("auditTrail/report", data);
  } catch (error) {
    if (error && error.response) return error.response;
    throw error;
  }
}

export async function getAuditTrailReportDetail(reportId) {
      return callGetApiv2("auditTrail/report/" + reportId);
}